var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 447,
    viewBox: "0 0 673 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    width: 442,
    height: 407,
    rx: 50,
    fill: "#1888B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M370.006 93.0405C336.763 73.5751 298.389 64.6745 259.971 67.5189C221.554 70.3633 184.908 84.8183 154.894 108.967C124.88 133.116 102.916 165.818 91.9138 202.736C80.9117 239.654 81.3915 279.044 93.2896 315.684C105.188 352.323 127.942 384.48 158.535 407.891C189.129 431.301 226.115 444.859 264.591 446.767C303.066 448.675 341.213 438.842 373.972 418.573C406.731 398.303 432.554 368.555 448.019 333.273L429.027 324.948C415.25 356.38 392.244 382.882 363.061 400.939C333.877 418.996 299.894 427.756 265.618 426.056C231.341 424.357 198.391 412.278 171.137 391.423C143.883 370.567 123.612 341.92 113.012 309.279C102.413 276.639 101.985 241.547 111.787 208.658C121.588 175.769 141.155 146.637 167.893 125.123C194.631 103.61 227.277 90.7326 261.502 88.1987C295.727 85.6647 329.913 93.594 359.528 110.935L370.006 93.0405Z",
    fill: "#D0E9E2",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349.418 126.803C323.086 111.385 292.689 104.334 262.259 106.587C231.828 108.84 202.801 120.29 179.027 139.419C155.253 158.547 137.854 184.45 129.14 213.694C120.425 242.937 120.805 274.138 130.229 303.16C139.654 332.182 157.678 357.654 181.911 376.198C206.144 394.741 235.441 405.481 265.918 406.992C296.394 408.503 326.61 400.715 352.559 384.659C378.508 368.604 398.963 345.04 411.212 317.092L396.168 310.499C385.256 335.396 367.033 356.388 343.917 370.691C320.8 384.994 293.882 391.933 266.731 390.587C239.581 389.24 213.481 379.673 191.893 363.153C170.304 346.633 154.248 323.942 145.852 298.087C137.456 272.232 137.117 244.436 144.881 218.385C152.645 192.333 168.144 169.257 189.323 152.216C210.503 135.175 236.362 124.975 263.471 122.968C290.581 120.961 317.66 127.242 341.118 140.978L349.418 126.803Z",
    fill: "#D0E9E2",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfCircle);
export default __webpack_public_path__ + "static/media/half-circle.91cb1f44b52a2e43f772c5d1479e543a.svg";
export { ForwardRef as ReactComponent };